import { FC } from 'react';
import CommonHeader from '../CommonHeader';

interface IAuthHeaderProps{}

const AuthHeaders: FC<IAuthHeaderProps> = ()=>{
  return <CommonHeader/>;
}

export default AuthHeaders;